<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card
        class="mx-auto my-2 fake-link d-flex"
        :elevation="hover || selectedEvent == taskEvent ? 6 : 0"
        :class="selectedEvent == taskEvent ? 'user-selected' : ''"
        tile
        @click="selectTask(taskEvent)"
      >
        <div class="align-self-center">
          <v-icon color="green" v-if="taskEvent.closedAt">mdi-check-circle-outline</v-icon>
          <v-icon v-else :color="taskEvent.snoozeUntil ? 'selection' : 'grey'">mdi-circle-outline</v-icon>
        </div>
        <div>
          <v-card-subtitle class="pb-0 my-0 pt-2">
            {{ fancyShortDate(taskEvent.createdAt) }}
          </v-card-subtitle>
          <v-card-title class="pt-0">
            <span
              class="block overline text-capitalize text-h6"
              :class="
                selectedEvent == taskEvent ? 'font-weight-bold navy--text' : 'font-weight-regular grey-navy--text'
              "
            >
              {{ taskEvent.title }}
            </span>
          </v-card-title>
          <v-card-subtitle class="d-flex justify-space-between pb-2">
            <span class="text--disabled">
              {{ taskEvent.taskType.title }}
            </span>
            <span v-if="taskEvent.snoozeUntil"
              ><v-icon color="selection">mdi-calendar</v-icon>
              {{ taskEvent.snoozeUntil }}
            </span>
          </v-card-subtitle>
        </div>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import { fancyShortDate } from "@/lib/fancy_date";

export default {
  name: "UserTasks",
  props: {
    taskEvent: {
      required: true,
    },
    selectedEvent: {
      required: false,
    },
  },
  methods: {
    selectTask(event) {
      this.$emit("select", event);
    },
    fancyShortDate(date) {
      return fancyShortDate(date);
    },
  },
};
</script>
